import React from 'react';

import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';
import { GreekIslandsPageDescriptionAndImageItemViewModel } from '@api/v3';

const DesktopGreekIslands = dynamic(() => import('./DesktopGreekIslands'));
const MobileGreekIslands = dynamic(() => import('./MobileGreekIslands'));

const GreekIslands = ({
  data,
}: {
  data?: GreekIslandsPageDescriptionAndImageItemViewModel;
}) => {
  const { isDesktop } = useDevice();

  return (
    <>
      {isDesktop ? (
        <DesktopGreekIslands data={data} />
      ) : (
        <MobileGreekIslands data={data} />
      )}
    </>
  );
};
export default GreekIslands;
